import React from "react";
import { makeStyles, IconButton } from "@material-ui/core";
import Icon from "@material-ui/core/Icon";
import actions from "src/duck/global/actions";
import { connect } from "react-redux";
const useStyles = makeStyles((theme) => ({
  version: {
    fontSize: 18,
  },
}));
const WcagButtons = ({ setWcagContrast, setWcagFont, ...rest }) => {
  const classes = useStyles();
  const contrastIcon = (
    <Icon>
      <img
        width="100%"
        alt="Wysoki kontrast"
        src={
          localStorage.getItem('wcagcontr') == "1"
            ? "/static/images/hicontrastbl.svg"
            : "/static/images/hicontrast.svg"
        }
      />
    </Icon>
  );

  const normalFontIcon = (
    <Icon>
      <img
        width="100%"
        alt="Normalny rozmiar czcionki"
        src={
          localStorage.getItem('wcagcontr') == "1"
            ? "/static/images/normalfontbl.svg"
            : "/static/images/normalfont.svg"
        }
      />
    </Icon>
  );

  const largeFontIcon = (
    <Icon>
      <img
        width="100%"
        alt="Powiększony rozmiar czcionki"
        src={
          localStorage.getItem('wcagcontr') == "1"
            ? "/static/images/largefontbl.svg"
            : "/static/images/largefont.svg"
        }
      />
    </Icon>
  );

  const toggleHighContrast = () => {
    if (localStorage.getItem('wcagcontr') === "1") {
      localStorage.removeItem('wcagcontr');
      setWcagContrast("0");
    } else {
      localStorage.setItem('wcagcontr', "1");
      setWcagContrast("1");
    }
  };

  const largeText = () => {
    localStorage.setItem('wcagfont', "1");
    setWcagFont("1");
  };

  const normalText = () => {
    localStorage.removeItem('wcagfont');
    setWcagFont("0");
  };

  return (
    <div>
      <IconButton
        color="secondary"
        variant="contained"
        title="Normalny rozmiar czcionki"
        aria-label="Normalny rozmiar czcionki"
        onClick={() => normalText()}
      >
        {normalFontIcon}
      </IconButton>
      <IconButton
        color="secondary"
        variant="contained"
        title="Powiększony rozmiar czcionki"
        aria-label="Powiększony rozmiar czcionki"
        onClick={() => largeText()}
      >
        {largeFontIcon}
      </IconButton>
      <IconButton
        color="secondary"
        variant="contained"
        title="Wysoki kontrast"
        aria-label="Wysoki kontrast"
        onClick={() => toggleHighContrast()}
      >
        {contrastIcon}
      </IconButton>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  setWcagContrast: (contrastValue) =>
    dispatch(actions.setWcagContrast(contrastValue)),
  setWcagFont: (fontsValue) => dispatch(actions.setWcagFont(fontsValue)),
});

export default connect(null, mapDispatchToProps)(WcagButtons);
